







    import { Component, Vue } from "vue-property-decorator";
    import HeadEl from '@/components/head/index.vue';
    import FootEl from '@/components/foot/index.vue';

	@Component({
        components: {
            HeadEl,
            FootEl
        }
    })
	export default class App extends Vue {

	}
